import { Component } from '@angular/core';

@Component({
  selector: 'app-creation-analysis-progress',
  templateUrl: './creation-analysis-progress.component.html'
})
export class CreationAnalysisProgressComponent {
  // Simple presentational component for an indeterminate analysis progress UI.
}
